import http from "../http/http-config";
import { getParamCotizResponse } from "../models/getParamCotizResponse "; 


export default new class ParamCotizService {

    setParamCotiz(data: any): Promise<string> {
        return http.post<string>("ParamCotiz/SetParamCotiz", data)
            .then(response => response.data);
    }

    getParamCotiz(Id: string): Promise<getParamCotizResponse> {
        return http
            .get<getParamCotizResponse>('ParamCotiz/GetParamCotiz',{
                params: {
                        Data: Id
                    }    
                })
            .then(r => r.data);
    }
}